import { API_BASE_URL } from "../../../config";

export const defaultFormTemplate = {
      menuID:null,
      menuName:null,
      module_name:null,
      menuLink:null,
      mobile_screen:'no',
      isParent:"yes",
      isClick:"yes",
      is_create_link:"no",
      linked:"n",
      is_custom:"n",
      menuIndex:999,
      module_desc:null,
      parentID:null,
      created_by:null,
      modified_by:null,
      created_date:null,
      modified_date:null,
      iconName:null,
      label:null,
      table_name:null,
      plural_label:null,
      custom_module:'no',
      status:'active',
      show_on_website:"no",
};
export const validationRules = {
  module_name: { required: true, maxLength: 100 },
  menuLink: {required: true, maxLength: 500},
};
export const defaultColumns = [
];
export const columnLabels = {
  "is_create_link":"Do you want to create Parent Menu?",
  "menuName":"Menu Name",
  "menuLink":"Module/Menu Link",
};

export const  skipFields=[];
export const  filterSkipFields=[];
export  const fieldOverrides = {
            module_desc:{
              type:"editor"
            },
            is_create_link:{
              type: 'radio',
              label: 'Do you want to create link?',
              options: [
                  { value: 'yes', label: 'Yes' },
                  { value: 'no', label: 'No' }
                ]
              },
              custom_module:{
              type: 'radio',
              label: 'Do you want to link exiting Module?',
              options: [
                  { value: 'yes', label: 'Yes' },
                  { value: 'no', label: 'No' }
                ]
              },
              mobile_screen:{
              type: 'radio',
              label: 'do you want to give access on Mobile?',
              options: [
                  { value: 'yes', label: 'Yes' },
                  { value: 'no', label: 'No' }
                ]
              },
              linked:{
              type: 'radio',
              label: 'Do you want to enable linking between modules?',
              options: [
                  { value: 'y', label: 'Yes' },
                  { value: 'n', label: 'No' }
                ]
              },
              
            status: {
              type: 'radio',
              label: 'Status',
              options: [
                  { value: 'active', label: 'Active' },
                  { value: 'inactive', label: 'In Active' }
                ]
              },
          };
export const directSchemaTemplate = [
  { Field: 'menuID', Type: 'int' },
  { Field: 'menuName', Type: 'varchar' },
  { Field: 'module_name', Type: 'varchar' },
  { Field: 'menuLink', Type: 'varchar' },
  { Field: 'table_name', Type: 'varchar' },
  { Field: 'mobile_screen', Type:  `enum(yes,no)` },
  { Field: 'is_create_link', Type:  `enum(yes,no)` },
  { Field: 'isParent', Type:  `enum(yes,no)` },
  { Field: 'isClick', Type:  `enum(yes,no)` },
  { Field: 'custom_module', Type:  `enum(yes,no)` },
  { Field: 'linked', Type:  `enum(y,n)` },
  { Field: 'is_custom', Type:  `enum(y,n)` },
  { Field: 'menuIndex', Type:  `varchar` },
  { Field: 'parentID', Type: 'smartSelectInput' },
  { Field: 'menuIndex', Type:  `varchar` },
  { Field: 'label', Type: 'varchar' },
  { Field: 'plural_label', Type:  `enum(yes,no)` },
  { Field: 'show_on_website', Type:  `enum(yes,no)` },
  { Field: 'modified_by', Type: 'int' },
  { Field: 'created_by', Type: 'smartSelectInput' },
  { Field: 'created_date', Type: 'date' },
  { Field: 'modified_date', Type: 'date' },
  { Field: 'module_desc', Type: 'varchar' },
  { Field: 'iconName', Type: 'varchar' },
  
  { Field: 'status', Type: `enum(active,inactive)` },
  
];
export const layout = [
    {
      label: 'Basic Info',
      row: [
     { field: 'is_create_link',colSize:'w-full mb-3 md:w-1/3' },
     { field: 'mobile_screen',colSize:'w-full mb-3 md:w-1/3'},
     { field: 'custom_module',showWhen: {
          field: 'is_create_link',
          value: 'no'
        }},
      ]
    },
    {
      row: [
      {field:'linked',colSize:'w-full mb-3 md:w-2/3',showWhen: {
          field: 'is_create_link',
          value: 'no'
        }},
      ]
    },
    {
      row: [
       { field: 'menuName'},
       { field: 'module_name',
        showWhen: {
          and: [{ field: 'custom_module', value: 'no' }, { field: 'is_create_link', value: 'no' }]
          }
        },
      ]
    },
    {
      row: [
      { field: 'label',colSize:'w-full mb-3 md:w-1/2',showWhen: {
          field: 'is_create_link',
          value: 'no'
        }},
      { field: 'plural_label',showWhen: {
          field: 'is_create_link',
          value: 'no'
        }},
       
      ]
    },
    {
      row: [
       { field: 'menuLink',colSize:'w-full mb-3 md:w-1/3',
        showWhen: {
          and: [{ field: 'custom_module', value: 'yes' }, { field: 'is_create_link', value: 'no' }]
          },
       },
      ]
    },
    {
      row: [
         { field: 'table_name',
          showWhen: {
          and: [{ field: 'custom_module', value: 'yes' }, { field: 'is_create_link', value: 'no' }]
          }
        },
      ]
    },
    {
      row: [
       { field: 'module_desc'},
      ]
    },
    {
      row: [
       { custom: 'iconName'},
      ]
    },
    {
      row: [
       { addcustomFieldBtn: true },{ customFieldsPlaceholder: true }
      ]
    },
  ];
  export const infoIcons = {
    custom_module: { show: true, text: 'Select yes to link the new module with existing system-defined modules' },
    mobile_screen: { show: true, text: 'Enabling this option allows access to this module from mobile.' },
    linked: { show: true, text: 'Turn on this option to connect this module with another. For example, link a Customer to their Invoices.' },
    menuLink: { show: true, text: `Used to navigate to the module via the address bar. For example, entering 'invoices' will result in a URL like https://www.example.com/invoices.`},
    menuName: { show: true, text: 'This name is used in the left sidebar navigation menu. e.g., Vendor List or Vendors' },
    module_name: { show: true, text: 'The module name is used for creating dynamic modules, e.g., Vendor List.' },
    label: { show: true, text: `Label used to display the form title when adding or editing a record. For example, if the label is 'Invoice', it will show 'Create Invoice' or 'Edit Invoice'.`},
    plural_label: { show: true, text: `This plural label is used as the title on the list page. For example, 'Invoices'.`}
  };